
<!-- FenomenShareForm.vue -->
<template> 
    <div>
        <!-- Paylaşım Türü -->
        <validation-provider
        v-slot="validationContext"
        name="Paylaşım Türü"
        rules="required"
        :value="localLinkData.link_type"
        v-if="localLinkData.platform==1"
        >
        <b-form-group label="Paylaşım Türü" label-for="link_type">
            <b-form-checkbox-group
            v-model="localLinkData.link_type"
            :options="linkTypeOptions"
            @change="emitUpdate"
            name="link_type"
            :state="getValidationState(validationContext)"
            switches
            :class="{'is-invalid' : validationContext.errors.length>0}"
            />
            <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
        </b-form-group>
        </validation-provider>


      <fenomen-selection
        :fenomen-list="fenomenList"
        :selected-inf-ids="selectedInfIds"
        :editing-link="editingLink"
        @update-selected="onUpdateSelected"
      />
      <validation-provider
        v-slot="validationContext"
        name="Paylaşım adı"
        rules="required"
      >
        <b-form-group
          label="Paylaşım adı (Bu başlık fenomen özelinde otomatik oluşturulacaktır.)"
          label-for="campaign_name"
        >
          <b-form-input
            id="campaign_name"
            v-model="localLinkData.campaign_name"
            :state="getValidationState(validationContext)"
            @input="emitUpdate"
            trim
          />
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

  
      <!-- Tarihler ve oranlar sadece profil fenomeni değilse -->
      <template v-if="!isProfilFenomen">
        <b-row>
          <b-col cols="6">
            <b-row>
              <b-col cols="7">
                <b-form-group label="Başlangıç Tarihi" label-for="start_date">
                  <b-form-datepicker
                    id="start_date"
                    v-model="startDate.date"
                    locale="tr"
                    :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
                    placeholder="Tarih seç"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="5" class="d-flex align-items-end">
                <b-form-group label-for="start_hour">
                  <b-form-timepicker
                    v-model="startDate.hours"
                    locale="tr"
                    no-close-button
                    hide-header
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col cols="7">
                <b-form-group label="Bitiş Tarihi" label-for="end_date">
                  <b-form-datepicker
                    id="end_date"
                    v-model="endDate.date"
                    locale="tr"
                    :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
                    placeholder="Tarih seç"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="5" class="d-flex align-items-end">
                <b-form-group label="Bitiş Saati" label-for="end_hour">
                  <b-form-timepicker
                    v-model="endDate.hours"
                    locale="tr"
                    no-close-button
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col cols="4" class="mt-2">
              <b-form-checkbox
                v-model="paymentTypeFixed"
                switch
              >
                Sabit ödeme kullan
              </b-form-checkbox>
          </b-col>  
          <b-col cols="4" v-if="!paymentTypeFixed">
            <b-form-group label="Link İçi Oran" label-for="link_ici_odeme_orani">
              <b-input-group prepend="%">
                <b-form-input
                  id="link_ici_odeme_orani"
                  v-model="localLinkData.link_ici_odeme_orani"
                  :disabled="paymentTypeFixed"
                  trim
                  @input="emitUpdate"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="4" v-if="!paymentTypeFixed">
            <b-form-group label="Dış Link Oran" label-for="link_disi_odeme_orani">
              <b-input-group prepend="%">
                <b-form-input
                  id="link_disi_odeme_orani"
                  v-model="localLinkData.link_disi_odeme_orani"
                  :disabled="paymentTypeFixed"
                  trim
                  @input="emitUpdate"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="4" v-if="paymentTypeFixed">
            <b-form-group label="Paylaşım ödemesi" label-for="link_ici_odeme_orani">
              <b-input-group append="₺">
                <b-form-input
                  id="payment_amount"
                  v-model="localLinkData.payment_amount"
                  :disabled="!paymentTypeFixed"
                  trim
                  @input="emitUpdate"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-between align-items-center">
          <label for="linkStatus">Link durumu</label>
          <b-form-checkbox
            id="linkStatus"
            v-model="localLinkData.status"
            switch
            @change="emitUpdate"
          />
        </div>
      </template>
    </div>
  </template>
  
  <script>
  import {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormCheckbox,
    BFormDatepicker,
    BFormTimepicker,
    BRow,
    BCol,
    BFormInvalidFeedback, 
    BFormCheckboxGroup,
    BFormRadio,
    BFormRadioGroup
  } from 'bootstrap-vue'
  import FenomenSelection from './FenomenSelection.vue'
  import { ValidationProvider } from 'vee-validate'
  
  export default {
    components: {
      BFormGroup,
      BFormInput,
      BInputGroup,
      BFormCheckbox,
      BFormDatepicker,
      BFormTimepicker,
      BRow,
      BCol,
      BFormCheckbox,
      BFormCheckboxGroup,
      BFormRadio,
      BFormRadioGroup,
      BFormInvalidFeedback,
      FenomenSelection,
      ValidationProvider
    },
    props: {
      linkData: { type: Object, required: true },
      selectedInfIds: { type: Array, required: true },
      fenomenList: { type: Array, required: true },
      editingLink: { type: Object, default: null },
      startDate: { type: Object, required: true },
      endDate: { type: Object, required: true }
    },
    computed: {
      isProfilFenomen() {
        return this.selectedInfIds.includes(1)
      }
    },
    data() {
        return {
            localLinkData: { 
            ...this.linkData,
            link_type: Array.isArray(this.linkData.link_type)
                ? this.linkData.link_type
                : (this.linkData.link_type ? this.linkData.link_type.split(',') : []),
            // platform: Array.isArray(this.linkData.platform)
            //     ? this.linkData.platform
            //     : (this.linkData.platform ? this.linkData.platform.split(',') : []),
            },
            linkTypeOptions: [
            { value: 'story', text: 'Story' },
            { value: 'post', text: 'Post' },
            ],
            paymentTypeFixed:false
        }
    },
    watch: {
        linkData: {
            handler(newVal) {
              this.localLinkData = { 
                  ...newVal,
                  link_type: Array.isArray(newVal.link_type)
                  ? newVal.link_type
                  : (newVal.link_type ? newVal.link_type.split(',') : []),
                  // platform: Array.isArray(newVal.platform)
                  // ? newVal.platform
                  // : (newVal.platform ? newVal.platform.split(',') : []),
              }
              
              if(this.paymentTypeFixed){
                this.localLinkData.link_ici_odeme_orani = null;
                this.localLinkData.link_disi_odeme_orani = null;
              } else {
                this.localLinkData.payment_amount = null;
              }
            },
            deep: true
        },
        
    },
    methods: {
      emitUpdate() {
        this.$emit('update', { ...this.localLinkData })
      },
      onUpdateSelected(val) {
        this.$emit('update-selected-inf-ids', val)
      },
      getValidationState(context) {
        if (context) return context.validated ? !context.invalid : null
        return null
      },
    },
  }
  </script>
  
  <style scoped>
  .b-form-radio-group .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #007bff; /* Change to your desired color */
      border-color: #007bff; /* Change to your desired color */
  }
  .demo-inline-spacing > * {
       margin-top:0 !important;
  }
  </style>